import { useQuery } from '@tanstack/react-query'

import { Media, PipelineJob, Prediction, ProgramV2 } from '@sparkai/shared-types'

import { apiClient } from '../../apiClient'

type Session = {
  operatorId: string
  dateStarted: string
  trainingModuleId: string
  trainingSessionId: string
  media: { location?: string | null }
  pipelineJobId: string
  pipelineJob: PipelineJob
  program: ProgramV2
  engagements: Engagement[]
  resolvedEngagementsCount: number
  remainingEngagementsCount: number
  avgAccuracy: number | null
  targetAccuracy: number | null
  avgTTC: number | null
  targetTTC: number | null
  state: 'unfinished' | 'finished'
  isCertified?: boolean | null
  detailedFeedback: boolean
}

type Engagement = {
  engagementId: string
  programConfigVersionId: string | null
  metadata: Record<string, unknown>
  predictions: Prediction[]
  media: Media[]
  defaultMediaId: string
}

export function useGetSession(sessionId?: string) {
  return useQuery({
    queryKey: ['training-module-session-id', sessionId],
    queryFn: async () => {
      const { data } = await apiClient.get<Session>(`/int/v3/engagements/training/sessions/${sessionId}`)
      return data
    },
    refetchOnWindowFocus: false,
    enabled: Boolean(sessionId),
  })
}
